import { useState, useEffect } from 'react';

import {
  // STAGE_STATUS_EMPTY,
  setStagesStatus,
  isProfileComplete,
} from 'utils/profile-stages';

export const useStagesWithStatus = (arr) => {
  const [loading, setLoading] = useState(true);
  const [stages, setStages] = useState(null);

  useEffect(() => {
    const getStagesStatus = async () => {
      setLoading(true);
      const a = await setStagesStatus(arr);
      setStages(a);
      setLoading(false);
    };
    if (arr != null && arr.length > 0) {
      getStagesStatus();
    } else {
      setStages(null);
      setLoading(false);
    }
  }, [arr]);

  return [stages, loading];
};

export const useIsProfileComplete = (stages) => {
  const [loading, setLoading] = useState(true);
  const [isComplete, setIsComplete] = useState(0);

  useEffect(() => {
    const getIsComplete = async () => {
      setLoading(true);
      const a = await isProfileComplete(stages);
      setIsComplete(a);
      setLoading(false);
    };

    if (stages.length > 0) {
      getIsComplete();
    } else {
      setLoading(false);
    }
  }, [stages]);

  return [isComplete, loading];
};
